/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiFrameSizeMaxIcon16Light } from './UiFrameSizeMaxIcon16Light';
import { UiFrameSizeMaxIcon16Regular } from './UiFrameSizeMaxIcon16Regular';
import { UiFrameSizeMaxIcon16Solid } from './UiFrameSizeMaxIcon16Solid';
import { UiFrameSizeMaxIcon20Light } from './UiFrameSizeMaxIcon20Light';
import { UiFrameSizeMaxIcon20Regular } from './UiFrameSizeMaxIcon20Regular';
import { UiFrameSizeMaxIcon20Solid } from './UiFrameSizeMaxIcon20Solid';
import { UiFrameSizeMaxIcon24Regular } from './UiFrameSizeMaxIcon24Regular';
import { UiFrameSizeMaxIcon24Solid } from './UiFrameSizeMaxIcon24Solid';
import { UiFrameSizeMaxIcon32Regular } from './UiFrameSizeMaxIcon32Regular';
import { UiFrameSizeMaxIcon64Regular } from './UiFrameSizeMaxIcon64Regular';
var sizes = {
    16: {
        light: UiFrameSizeMaxIcon16Light,
        regular: UiFrameSizeMaxIcon16Regular,
        solid: UiFrameSizeMaxIcon16Solid,
    },
    20: {
        light: UiFrameSizeMaxIcon20Light,
        regular: UiFrameSizeMaxIcon20Regular,
        solid: UiFrameSizeMaxIcon20Solid,
    },
    24: {
        regular: UiFrameSizeMaxIcon24Regular,
        solid: UiFrameSizeMaxIcon24Solid,
    },
    32: {
        regular: UiFrameSizeMaxIcon32Regular,
    },
    64: {
        regular: UiFrameSizeMaxIcon64Regular,
    },
};
export var UiFrameSizeMaxIcon = forwardRef('UiFrameSizeMaxIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
